import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { jwtDecode } from 'jwt-decode';  // Correct import here

import axios from 'axios';
import { API_BASE_URL } from '../ApiConfig';
import { showCustomAlert, showCustomAlerterror } from '../customalert';
import { getSecureToken } from '../ApisService/apiService';

const GoogleLoginComponent = ({ onLoginSuccess }) => {
    const navigate = useNavigate();

    const handleSuccess = async (credentialResponse) => {
        const { secrettoken, ts } = await getSecureToken();
       
        try {
            const token = credentialResponse.credential;
            const user = jwtDecode(token);
            // console.log("Decoded User:", user);

            const email = user?.email;
            const email_verified = user?.email_verified;

            if (!email_verified) {
                showCustomAlerterror("Your email is not verified by Google.");
                return;
            }

            // Send to PHP backend
            const response = await axios.post(`${API_BASE_URL}auth/google_auth.php`, {
                email: email
            },
                {
                    headers: {
                        'X-TOKEN': secrettoken,
                        'X-TIMESTAMP': ts
                    },
                    withCredentials: true
                });
            // console.log(response)

            if (response.data.status === "success") {
                showCustomAlert('Login successful');
                if (onLoginSuccess) {
                    onLoginSuccess();
                }
                const data = response.data.user;
                localStorage.setItem('isuserlogin', 'true');
                localStorage.setItem('autoLoginEmail', data.email);

                localStorage.setItem('userEmail', data.email);
                localStorage.setItem('fullName', data.full_name);
                localStorage.setItem('mobilenumber', data.mobile_number);
                localStorage.setItem('planexpire', data.subscription_date);
                setTimeout(() => {
                    navigate('/dashboard');
                }, 300);
            } else {
                showCustomAlerterror('Email does not exist in our system.');
            }
        } catch (err) {
            // console.error("Login Error:", err);
            showCustomAlerterror('Login failed');
        }
    };

    const handleError = () => {
        showCustomAlerterror('Google login failed');
    };

    return (
        <div>

            <GoogleLogin
                onSuccess={handleSuccess}
                onError={handleError}
            />
        </div>
    );
};

export default GoogleLoginComponent;
